@if (sourceItems.length || selection.length) {
  <p-pickList
    class="app-pick-list"
    filterBy="name"
    [source]="sourceItems"
    [target]="selection"
    [dragdrop]="true"
    [responsive]="true"
    breakpoint="1400px"
    sourceFilterPlaceholder="Durchsuchen"
    targetFilterPlaceholder="Durchsuchen"
    [showSourceControls]="false"
    [showTargetControls]="false"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }">
    <ng-template pTemplate="sourceHeader">
      <app-pick-list-header
        title="Intern sichtbar"
        [count]="sourceItems.length" />
    </ng-template>
    <ng-template pTemplate="targetHeader">
      <app-pick-list-header
        title="Zur Veröffentlichung"
        [count]="selection.length" />
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="pl-row">
        <i class="pl-icon" [class]="item.icon"></i>
        <div class="pl-body">
          <span class="pl-name">{{ item.name }}</span>
          <span class="pl-meta">{{ typeLabels[item.type] }}</span>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessagesource">
      <div class="pl-empty">Keine weiteren Einträge.</div>
    </ng-template>
    <ng-template pTemplate="emptyfiltermessagesource">
      <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
    </ng-template>
    <ng-template pTemplate="emptymessagetarget">
      <div class="pl-empty">
        Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen übernehmen.
      </div>
    </ng-template>
    <ng-template pTemplate="emptyfiltermessagetarget">
      <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
    </ng-template>
  </p-pickList>

  <p-divider />

  <footer class="flex align-items-center justify-content-end gap-3">
    <p-button
      (click)="resetSelection()"
      [rounded]="true"
      [text]="true"
      [disabled]="!selection.length"
      severity="secondary"
      label="Auswahl leeren"
      icon="fas fa-xmark"></p-button>
    <p-button
      [disabled]="!selection.length"
      (click)="confirm($event)"
      [rounded]="true"
      label="Auswahl veröffentlichen"
      icon="fas fa-earth-europe"></p-button>
  </footer>
}
